<template>
    <v-card class="soli-round pa-0" flat>
        <v-container class="px-3" fluid>
            <v-skeleton-loader
                type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line,list-item-avatar-three-line"
                class="mb-6 pl-1 pt-2"
                style="max-width: 600px"
                boilerplate
                v-if="!attendances"
            ></v-skeleton-loader>
            <v-data-table
                v-if="attendances"
                :headers="headers"
                :items="attendances"
                :search="search"
                :loading="loading"
                :disable-sort="$vuetify.breakpoint.xs"
                group-by="lesson.id"
                hide-default-footer
                disable-pagination
                no-data-text="No lessons found"
                @click:row="$log($event.id)"
            >
                <template
                    v-slot:[`group.header`]="{ group, items, isOpen, toggle }"
                >
                    <th colspan="1">
                        <tr>
                            <AttendanceDate
                                v-if="items[0]"
                                :date="items[0].lesson.starts_at"
                            />
                        </tr>
                    </th>
                    <th colspan="1">
                        <tr>
                            <div v-if="items[0]" class="py-4">
                                <AttendanceInfo :attendance="items[0]" />
                                <AttendanceTitle :attendance="items[0]" />
                                <AttendanceLesson :lesson="items[0].lesson" />
                            </div>
                        </tr>
                    </th>
                </template>
                <template v-slot:[`item.lesson.starts_at`]="{ item }">
                    <AttendanceDate :date="item.lesson.starts_at" />
                </template>

                <template v-slot:[`item.lesson.details`]="{ item }">
                    <div class="py-4">
                        <AttendanceInfo :attendance="item" />
                        <AttendanceTitle :attendance="item" />
                        <AttendanceLesson :lesson="item.lesson" />
                    </div>
                </template>

                <template v-slot:[`item.purchaseOption.name`]="{ item }">
                    <AttendanceOption
                        :attendance="item"
                        :purchaseOption="item.purchaseOption"
                        @success="$emit('success')"
                        @reset="$emit('reset')"
                    />
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <AttendanceStatus
                        :attendance="item"
                        :student="user"
                        @success="$emit('success')"
                        @reset="$emit('reset')"
                    />
                </template>
            </v-data-table>
        </v-container>
    </v-card>
</template>

<script>
import globalMoment from "../../../Mixins/GlobalMoment.js";
import AttendanceDate from "./AttendanceDate.vue";
import AttendanceLesson from "./AttendanceLesson.vue";
import AttendanceTitle from "./AttendanceTitle.vue";
import AttendanceOption from "./AttendanceOption.vue";
import AttendanceInfo from "./AttendanceInfo.vue";
import AttendanceStatus from "./AttendanceStatus.vue";
import ReportHeader from "../../Reports/ReportHeader.vue";

export default {
    mixins: [globalMoment],
    props: {
        attendances: {
            type: Array,
            default: null,
        },
        user: {},
        dateRange: {
            type: Array,
            default: () => [],
        },
        errors: {},
    },
    components: {
        AttendanceDate,
        AttendanceLesson,
        AttendanceTitle,
        AttendanceOption,
        AttendanceStatus,
        AttendanceInfo,
        ReportHeader,
    },
    data: function () {
        return {
            loading: false,
            search: "",
            headers: [
                {
                    text: "When",
                    value: "lesson.starts_at",
                    sortable: true,
                    align: "center",
                },
                {
                    text: "Lesson",
                    value: "lesson.details",
                    sortable: false,
                    align: "start",
                },
                {
                    text: "Purchase Option",
                    value: "purchaseOption.name",
                    sortable: true,
                    align: "start",
                },
                {
                    text: "Status",
                    value: "status",
                    sortable: true,
                    align: "start",
                },
            ],
        };
    },
};
</script>
